module.exports = __webpack_public_path__ + "img/box 1.3af19a8c.svg";